import { useEffect, useRef, useState } from "react";
import { FiX } from "react-icons/fi";
import emojis from "../../shared/channelEmojis";

export default function ChannelEmojiPicker({ onSelect, onClose }) {
  const dialog = useRef(null);
  const [search, setSearch] = useState("");
  useEffect(() => { dialog.current.showModal(); }, []);
  return <dialog ref={dialog} className="channel-emoji-dialog" aria-label="Choose emoji" onCancel={event => { event.preventDefault(); onClose(); }}>
    <div className="flex items-center gap-2"><input autoFocus aria-label="Search emoji" placeholder="Search emoji" value={search} onChange={event => setSearch(event.target.value)} /><button type="button" title="Close emoji picker" aria-label="Close emoji picker" onClick={onClose}><FiX /></button></div>
    <div className="channel-emoji-grid">{emojis.filter(([, name]) => name.toLowerCase().includes(search.toLowerCase())).map(([emoji, name]) => <button key={name} type="button" aria-label={name} title={name} onClick={() => { onSelect(emoji); onClose(); }}>{emoji}</button>)}</div>
  </dialog>;
}
